import React, { useState, useRef, useEffect } from "react";
import CheckIcon from "../assets/images/check.svg";

const CheckBox = ({ name, value, placeholder, onChange }) => {
    const dropdownRef = useRef(null);

    // Handle option selection
    const handleOptionClick = (option) => {
        onChange(name, !value);
    };

    return (
        <>
            <div
                ref={dropdownRef}
                style={{
                    position: "relative",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column"
                }}>
                <div className="dropdown-content" onClick={handleOptionClick}>
                    <div
                        style={{
                            height: 20,
                            width: 20,
                            borderRadius: "50%",
                            border: "1px solid #FFF",
                            position: "absolute",
                            left: 10,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            transitionDuration: "0.4s",
                            backgroundColor: value ? "#0166EE" : ""
                        }}>
                        <img
                            style={{ opacity: value ? 1 : 0, transitionDuration: "0.4s" }}
                            src={CheckIcon}
                        />
                    </div>
                    <div className="dropdown-text">{placeholder}</div>
                </div>
                
            </div>
        </>
    );
};

export default CheckBox;
